import Vue from 'vue'
import Vuex from 'vuex'
import loader from './loader'
import snackbar from './snackbar'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    loader,
    snackbar
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js